/* KASRIVA — browser-generated, high-entropy case reference.
 * Replaces the technical contact[id] field shown in Shopify notifications.
 * This is NOT a sequential ticket counter; such a counter requires a backend.
 */
(() => {
  'use strict';

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const field = form.querySelector('input[data-kasriva-case-reference]');
    if (!(field instanceof HTMLInputElement) || field.value) return;

    // The Shopify storefront is served over HTTPS, which provides Web Crypto.
    if (!globalThis.crypto || typeof crypto.getRandomValues !== 'function') return;
    const bytes = new Uint8Array(8);
    crypto.getRandomValues(bytes);
    const nonce = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('').toUpperCase();
    const date = new Date().toISOString().slice(0, 10).replace(/-/g, '');
    field.value = `KAS-${date}-${nonce}`;
  }, true);
})();
